module.exports = __webpack_public_path__ + "img/iconos-ilustracion-08.de9f589c.jpg";